import type { FEATURE_GRID_DATA, FEATURE_GRID_PARAMS } from './types'

export const DEFAULT_FEATURE_GRID_DATA = (): FEATURE_GRID_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'feature-grid',
  theme: 'light',
  image: { document: null, hash: null },
  heading: 'Nadpis sekce',
  items: [
    {
      icon: '/img/icons/resimbydleni.svg',
      title: 'Položka',
      text: 'Krátký popis položky.',
      comingSoon: false,
    },
  ],
})

export const DEFAULT_FEATURE_GRID_PARAMS = (): FEATURE_GRID_PARAMS => ({
  pc: { hidden: false },
  tablet: { hidden: false },
  mobile: { hidden: false },
})
